export const pharmacyTags = {
  DRUGS: 'Drugs',
  EXPENSE: 'Expense',
  HAS_EXPENSE: 'hasExpense',
};
